module.exports = __webpack_public_path__ + "img/AD.5f3621e1.png";